export const worldRu = {
  'world.seo.title': 'Мир',
  'world.seo.description':
    'Исследуй интерактивные карты Grymwyrd — его королевства, руины и легендарные места в 2D-картографии и вращаемом 3D-глобусе.',
  'world.heading': 'Мир',
  'world.intro':
    'Начерти вечные сумерки. Атлас построен для послойного исследования — масштабируй от всего мира до отдельного подземелья. Сейчас интерактивен только верхний уровень; более глубокие слои откроются по мере картографии королевств.',

  'world.viewMode.label': 'Режим вида карты',
  'world.viewMode.map2d': '2D-карта',
  'world.viewMode.globe3d': '3D-глобус',

  'world.gazetteer.navLabel': 'Локации и сцены',
  'world.gazetteer.heading': 'Географический справочник',
  'world.gazetteer.sampleNotice':
    'Показаны образцы мест — истинный обзор картографа ещё не записан.',
  'world.gazetteer.error': 'Не удалось достичь архива атласа.',

  'world.loading.atlas': 'Раскручиваю атлас…',
  'world.loading.globe': 'Вращаю мир…',

  'world.layersActive': 'Активно {active} из {total} слоёв.',
  'world.globeHint':
    'Перетаскивай для вращения (авто-вращение приостанавливается во время исследования, возобновляется через минуту неподвижности); прокручивай для приближения. Наведи на гекс, чтобы увидеть его кампанию, кликни для входа.',
  'world.webglUnavailable':
    '3D-глобус требует WebGL, который здесь недоступен — показываю 2D-атлас.',

  'world.campaign.capitalRegion': 'Столичный регион',
  'world.campaign.territory': 'Территория кампании',
  'world.campaign.enter': 'Войти в кампанию',
  'world.campaign.stay': 'Остаться на орбите',

  'world.layers.heading': 'Слои карты',
  'world.layers.gmBadge': 'Мастер',
  'world.layers.gmRequired': 'Требуется роль Мастера игры.',

  'world.marker.sampleBadge': 'Образец данных',
  'world.marker.viewInEncyclopedia': 'Просмотреть в Энциклопедии',
  'world.marker.placeholderNote':
    'Это заглушка локации — когда её история будет написана, она свяжется с Энциклопедией.',

  'world.map2d.ariaLabel': 'Интерактивная карта надмира',
  'world.map2d.noOverworld': 'Картография надмира ещё не начертана — показываю пустоту',

  'world.globe.hint.enter': 'Вход ▸',
  'world.globe.hint.open': 'Открыть ▸',
  'world.globe.hint.claim': 'Захватить ▸',
  'world.globe.uncharted': 'Неизведанные пределы',
  'world.globe.unchartedBlurb':
    'Ни одна кампания не завладела этим гексом вечных сумерек. Водрузи первый стяг.',
  'world.globe.capitalLabel': 'Grymwyrd',
} as const
